<script setup lang="ts">
import useLocale from '../../composables/useLocale';
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMessageCaptions } from '@fortawesome/pro-solid-svg-icons';
library.add(faMessageCaptions);

type Emits = {
  (e: 'update:model-value', value: boolean | null): void;
};
const emit = defineEmits<Emits>();

type Props = {
  modelValue: boolean;
  hasAudioTracking?: boolean;
  disabled?: boolean;
};
const props = defineProps<Props>();
const { t } = useLocale();
const { smAndDown } = useDisplay();

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:model-value', val),
});
</script>
<template>
  <v-list-item
    :disabled="disabled"
    density="compact"
    prepend-icon="mdi-message-bulleted"
    data-testid="bp-setting-audio-tracking"
    :title="hasAudioTracking ? t('label_sentence_highlighting_on') : t('label_sentence_highlighting_off')"
  >
    <template #prepend>
      <FontAwesomeIcon class="pr-3" :size="!smAndDown ? 'xl' : 'lg'" icon="fa-solid fa-message-captions" />
    </template>
    <template #append>
      <v-switch v-model="value" :disabled="disabled" class="pl-4" color="primary" hide-details inset />
    </template>
  </v-list-item>
</template>

<style scoped lang="scss">
:deep(.v-switch__track) {
  opacity: 1;
}
:deep(.v-icon) {
  opacity: 1 !important;
}
:deep(.v-switch .v-switch__track) {
  background-color: rgb(var(--v-theme-secondary));
}
</style>
